import { ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { KnowledgeCheck } from "../../models/KnowledgeCheck";
import { CreateKnowledgeCheckRequest } from "./CreateKnowledgeCheckRequest";
import { EditKnowledgeCheckRequest } from "./EditKnowledgeCheckRequest";
import { SearchKnowledgeCheckRequest } from "./SearchKnowledgeCheckRequest";

const knowledgeCheckUrlPrefix: string = "knowledge-checks";
export const searchKnowledgeChecks = async (request: SearchKnowledgeCheckRequest) => {
  let result = await api.get(
      `${knowledgeCheckUrlPrefix}/search`,
      request
  ) as PagedResult<KnowledgeCheck>;
  setDatesKnowledgeChecks(result.results);
  return result;
}

export const getKnowledgeCheckById = async (id: number) => {
  let result = await api.get(
      `${knowledgeCheckUrlPrefix}/${id}`
  ) as KnowledgeCheck;
  setDatesKnowledgeCheck(result);
  return result
}

export const createKnowledgeCheck = async (request: CreateKnowledgeCheckRequest) => {
  return api.post(
      `${knowledgeCheckUrlPrefix}`,
      request
  ) as Promise<number>
}

export const editKnowledgeCheck = async (id: number, request: EditKnowledgeCheckRequest) => {
  return api.put(
      `${knowledgeCheckUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const deleteKnowledgeCheck = async (id: number) => {
  return api.delete(
      `${knowledgeCheckUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportKnowledgeChecks = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${knowledgeCheckUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

const setDatesKnowledgeChecks = (items: KnowledgeCheck[]) => {
  for (let item of items) {
    setDatesKnowledgeCheck(item);
  }
}

const setDatesKnowledgeCheck = (item: KnowledgeCheck) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}